import { UserInfo } from '@wui/common-library'
import { ref } from 'vue'

const LOCAL_STORAGE_KEY = 'wc-user-data'
const SESSION_STORAGE_KEY = 'wc-user-id'

const currentUser = ref<UserInfo | undefined>()

const initCurrentUser = () => {
  const userId = sessionStorage.getItem(SESSION_STORAGE_KEY)
  const userData = localStorage.getItem(`${userId}-${LOCAL_STORAGE_KEY}`)
  if (userData) {
    try {
      const user = JSON.parse(userData)
      currentUser.value = user
    } catch (e) {
      console.error(e)
    }
  } else {
    const userData = localStorage.getItem(`${LOCAL_STORAGE_KEY}`)
    if (userData) {
      try {
        const user = JSON.parse(userData)
        currentUser.value = user
      } catch (e) {
        console.error(e)
      }
    }
  }
}

const setCurrentUser = (userData: UserInfo) => {
  currentUser.value = userData

  sessionStorage.setItem(SESSION_STORAGE_KEY, userData.guid)
  localStorage.setItem(`${userData.guid}-${LOCAL_STORAGE_KEY}`, JSON.stringify(userData))
  // #fallback user data
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(userData))
}

const setCurrentUserField = <K extends keyof UserInfo>(field: K, value: UserInfo[K]) => {
  if (currentUser.value) {
    currentUser.value[field] = value

    localStorage.setItem(`${currentUser.value.guid}-${LOCAL_STORAGE_KEY}`, JSON.stringify(currentUser.value))
    // #fallback user data
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(currentUser.value))
  }
}

const clearCurrentUser = () => {
  if (currentUser.value) {
    localStorage.removeItem(`${currentUser.value.guid}-${LOCAL_STORAGE_KEY}`)
  }

  localStorage.removeItem(LOCAL_STORAGE_KEY)
  sessionStorage.removeItem(SESSION_STORAGE_KEY)

  currentUser.value = undefined
}

export const useCurrentUser = () => {
  return {
    currentUser,
    initCurrentUser,
    setCurrentUser,
    setCurrentUserField,
    clearCurrentUser,
  }
}
